<template>
  <v-list dense outlined class="rounded-lg">
    <slot />
  </v-list>
</template>

<script>
export default {
  name: 'List',
};
</script>
